<template>
  <!-- 导航开始 -->
  <div class='commonClientinfoTrace' :class="{scrollHide: isShowTraceStoreBox}" ref="scrollBox">
    <div class="listBox">
      <div class="timeline-item blue" v-for="(app,index) in data" :date-is="app.addtime_str" :key="index">
        <span class="title"><span href="javascript:void(0);">{{app.userid_str}}</span></span>
        <div class="">
          <span class="hovers description">{{app.contents}}</span>
          <span class="description">{{app.usercalls_str}}</span>
        </div>
      </div>
      <div v-if="!is_empty">
        <div v-if='isLoading  && !isSearchLoading' class='dynamicMessage'>
          <i class='iconfont icon-jiazai xuanzhuan'></i>
        </div>
        <div v-if='isNodata' class='dynamicMessage'>
          — 没有更多了 —
        </div>
        <div v-if='isError' class='dynamicMessage'>
          — 请求失败 —
        </div>
      </div>
      <div class="emptyBox" v-if="is_empty && data.length===0">
        <i class="iconfont icon-kong"></i>
      </div>
    </div>

    <div v-if="isShowTraceStoreBox" class="traceStoreBoxModel" @click.self="isShowTraceStoreBox=false">
      <div class="traceStoreBox">
        <div class="xuanzeBox mb-3">
          <multiselect v-model="informVal" :hideSelected="true" :options="informArr" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="@同事" label="name" track-by="id">
            <template slot="selection" slot-scope="{ values, search, isOpen }">
              <span class="multiselect__single" v-if="informVal.length &amp;&amp; !isOpen">{{informValStr}}</span>
            </template>
          </multiselect>
        </div>
        <div class="textareaBox mb-3">
          <textarea class="form-control" aria-label="With textarea" v-model="contentVal"></textarea>
        </div>
        <div class="anniuBox">
          <button type="button" @click="submitFun()" class="btn btn-success btn-round"><i v-if="isSubmitLoading" class='iconfont icon-jiazai xuanzhuan'></i> 立即跟进</button>
        </div>
      </div>
    </div>
    <div class="searchLoadingBox" v-if="isSearchLoading">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
    <span v-if="!isShowTraceStoreBox" @click="showFromFun(true)" class="tianjia btn btn-success btn-round">维护</span>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import commons from '../../../util/commons';
import { apiCrmPactTracestore } from '../../../request/api';

export default {
  name: 'CommonClientinfoTrace',
  props: ['token', 'rootContractUnitIsSuccessFun'],
  data() {
    return {
      // 是否显示跟进表单
      isShowTraceStoreBox: false,
      // @人
      informVal: [],
      // 跟进内容
      contentVal: '',
      // 类型
      typeArr: [
        { id: 1, name: '电话回访' },
        { id: 2, name: '微信沟通' },
        { id: 3, name: '公司面谈' },
        { id: 4, name: '活动到访' },
        { id: 5, name: '上门拜访' },
      ],
      // @用户
      informArr: [
        { id: 1, name: '张三' },
        { id: 2, name: '李四' },
        { id: 3, name: '王二麻' },
        { id: 4, name: '小红' },
        { id: 5, name: '小兰' },
      ],

      isSubmitLoading: false,
      // 分页
      data: [], // 数据队列
      allPage: 0, // 总页数
      allNumber: 0, // 总页数
      page: 1, // 当前页数
      is_empty: false, // 是否为空数据(没有任何数据)
      isNodata: false, // 没有更多了
      isLoading: false, // 是否请求中
      isError: false, // 请求失败
      diffuser: '',
      // 加载中
      isSearchLoading: true,
    };
  },
  computed: {
    // 选中的类型
    informValStr() {
      const arr = [];
      this.informVal.forEach((app) => {
        arr.unshift(app.name);
      });
      return `@${arr.join(',')}`;
    },
    // 条件
    whereJson() {
      return {
        page: this.page,
        token: this.token,
      };
    },
    submitData() {
      let arr;
      // 跟进
      return {
        token: this.token,
        usercalls: commons.whereArrStr(this.informVal),
        contents: this.contentVal,
      };
    },
  },
  methods: {
    // 弹出跟近框
    showFromFun(bool) {
      this.contentVal = '';
      this.informVal = [];
      this.isShowTraceStoreBox = bool;
    },
    // 状态切换
    loadingFun(bool) {
      if (bool === 1) {
        // 加载中
        this.isNodata = false;
        this.isError = false;
        this.isLoading = true;
      } else if (bool === 2) {
        // 关闭所有
        this.isNodata = false;
        this.isError = false;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      } else if (bool === 3) {
        // 没有更多了
        this.isNodata = true;
        this.isError = false;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      } else {
        // 请求失败了
        this.isNodata = false;
        this.isError = true;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      }
    },
    // 初始化个人的
    initData(reload = false) {
      if (reload) {
        this.data = [];
        this.allPage = 0;
        this.page = 1;
        this.allNumber = 0;
        this.is_empty = false; // 是否为空数据(没有任何数据)
        this.isNodata = false; // 没有更多了
        this.isLoading = false; // 是否请求中
        this.isError = false; // 请求失败
        this.isSearchLoading = true; // 悬浮加载中
      }
      return resultCommons.apiCrmPactTrace(this, this.whereJson, reload).then((ob) => {});
    },
    scroll(that, node) {
      node.onscroll = () => {
        // 距离底部200px时加载一次
        const bottomOfWindow = node.scrollHeight - node.scrollTop - node.clientHeight <= 150;
        console.log(bottomOfWindow);
        // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
        if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
          this.initData();
        }
      };
    },
    submitFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      this.isSubmitLoading = true;
      this.runNumber += 1;
      resultCommons.apiCrmPactTracestore(this, this.submitData).then((ob) => {
        console.log(ob);
        EventBus.$emit('globalZhezhaoBoxFun', false);
        this.isSubmitLoading = false;
        if (ob.state === 200) {
          const info = ob.data.info;
          this.data.unshift(info);
          this.isShowTraceStoreBox = false;
          this.rootContractUnitIsSuccessFun(3, { token: this.token });
          this.$message.showMsgBox({
            type: 'success',
            content: ob.message,
          });
        } else {
          this.$message.showMsgBox({
            type: 'warning',
            content: ob.message,
          });
        }
      });
    },
  },
  components: {
    Multiselect,
  },
  created() {
    // 初始化
    this.initData().then((app) => {
      this.isSearchLoading = false;
      resultCommons.apiUserZaizhi(this, {}).then((ob) => {
        if (ob.state === 200) {
          this.informArr = ob.data.filter(app => app.id !== this.diffuser);
        } else {
          // 请求失败
          this.$message.showMsgBox({
            type: 'warning',
            content: '请求失败',
          });
        }
      });
    });
  },
  mounted() {
    // 创建事件
    this.scroll(this, this.$refs.scrollBox);
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonClientinfoTrace{
  flex: 1;
  overflow-y: auto;
  padding: 15px;
  padding-left: 25px;
  background: #FFFFFF;
  div.traceStoreBoxModel{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.1);
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    div.traceStoreBox{
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
      padding: 30px 15px;
      background: #FFFFFF;
      div.xuanzeBox{
        display: flex;
        flex-direction: row;
        div{
          flex: 1;
        }
      }
      div.biaodanBox{
        .custom-file-label::after{
          content: '选择附件';
        }
      }
      div.textareaBox{
        textarea{
          height: 150px;
          border-radius: 5px;
        }
      }
      div.anniuBox{
        text-align: right;
      }
    }
  }
  span.tianjia{
    position: absolute;
    display: inline-block;
    width: 90px;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    margin-bottom: 20px;
    text-align: center;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
  }
  div.listBox{
    min-height:100%;
    display: flex;
    flex-direction: column;
    div.menuBox{
      text-align: right;
      margin: 0;
      margin-bottom: 10px;
      .badge{
        cursor: pointer;
        margin-left: 0;
        font-size: 14px;
        font-weight: 300;
        &.badge-light{
          color: #FFFFFF;
          background: #9FA5AA;
        }
      }
    }
    .timeline-item{
      padding: 2.8em 2em 2em;
      padding-bottom: 0.5rem;
      padding-right: 0;
      div.msg{
        margin: 5px 0;
        margin-bottom: 0;
        color: #666666;
        font-size: 14px;
        a{
          display: inline-block;
        }
      }
      div.huifu{
        background: rgba(0,0,0,0.03);
        border: 1px solid rgba(0,0,0,0.1);
        color: #999999;
        border-radius: 6px;
        padding:0.5rem 0.8rem;
        margin-top: 6px;
        font-size: 13px;
        line-height: 1.5em;
        //font-style: italic;
      }
      span.hovers{
        display: block;
      }
      .title{
        font-family: 'gilroy-semibold';
        text-transform: capitalize;
      }
      &::after{
        top: 1.2em;
      }
    }
    div.emptyBox{
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      i{
        font-size: 70px;
        color: rgba(0,0,0,0.1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/contractinfo/trace.vue